import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";


export function useReadAllNotification() {

  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/notification/read/all`
        )
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(['notifications'])
      },
      onError: (error) => {
       
      },
    }
  );

  return {
    loading: isLoading,
    readAll: mutate,
  };
}


export function useReadSingleNotification() {

  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/notification/read/${data.id}`
        )
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(['notifications'])
      },
      onError: (error) => {
       
      },
    }
  );

  return {
    loading: isLoading,
    readSingle: mutate,
  };
}